module.exports = __webpack_public_path__ + "static/media/undraw_team_ih79.13e9ea5b.svg";